// extracted by mini-css-extract-plugin
export default {"overlay":"Ow-z","bodyOpen":"Pw-z","content":"Qw-z","header":"Rw-z","close":"Sw-z","closeNoHeading":"Tw-z"};